<template>
    <div class="container-fluid">
    <div id="blog">
        <div class="portlet light portlet-fit" style="">
            <div class="portlet-title">
                <div class="caption">
                    <i class="icon-pencil font-red-sunglo"></i>
                    <span class="caption-subject font-red-sunglo uppercase bold">Rédiger une News</span>
                </div>
            </div>
            <div class="tabbable-line">
            </div>
            <div class="portlet-body">
                <div class="portlet-form">
                    <blog-form :post="this.originalPost"></blog-form>
                </div>
            </div>
        </div>
        <div class="portlet light portlet-fit" style="">
            <div class="portlet-title">
                <div class="caption">
                    <i class="icon-pencil font-red-sunglo"></i>
                    <span class="caption-subject font-red-sunglo uppercase bold">Ajouter des photos</span>
                </div>
            </div>
            <div class="tabbable-line">
            </div>
            <div class="portlet-body">
                <div class="portlet-form">
                    <image-multi-upload 
                        name="portfolio"
                        title="Images de portfolio"
                        :nbr-images="9">
                    </image-multi-upload>
                </div>
            </div>
        </div>
        <button type="submit" class="btn btn-right btn-danger" id="btn-post"> Annuler </button>
        <button type="submit" class="btn btn-right btn-primary" id="btn-post" @click="send()"> Envoyer ! </button>
    </div>
</div>
</template>

<script>
export default {

  name: 'blog',
  props: {
    post: null,
  },
  data () {
    return {
        images: undefined,
        illustration: {},
        portfolio: [],
        originalPost: {}
    }
  },
  mounted () {
        this.post === undefined ? this.originalPost = undefined : this.originalPost = Object.assign({}, JSON.parse(this.post))

        if (this.originalPost != undefined) {
            this.originalPost.images === undefined ? undefined : this.images = Object.assign({}, this.originalPost.images)
            if (this.originalPost != undefined) {
                Event.fire('update-post', this.originalPost)
            }
            for (var i = this.originalPost.images.length - 1; i >= 0; i--) {
                if (this.originalPost.images[i].name ==='illustration') {
                    this.illustration = this.originalPost.images[i]
                }
                if (this.originalPost.images[i].name === 'portfolio') {
                    this.portfolio.push(this.originalPost.images[i])
                }
            }
            if (this.originalPost != undefined) {
                Event.fire('update-single-image', this.illustration)
            }
            if (this.portfolio != []) {
                Event.fire('update-multi-images', this.portfolio)
            }
        }
  },
  methods: {
    send() {
        Event.fire('create-news');
    }
  }
}
</script>

<style lang="css" scoped>
</style>
